import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-764a9068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-block" }
const _hoisted_2 = {
  key: 0,
  class: "btn-group-vertical",
  role: "group",
  style: {"width":"100%"}
}
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = ["for", "onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column mb-3" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Saved status")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-center justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border mt-3",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "position-relative"
}
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "emailTo",
  class: "form-label"
}, "To:", -1))
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "emailSubject",
  class: "form-label"
}, "Subject:", -1))
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "emailMessage",
  class: "form-label"
}, "Reply:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-copy" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_21 = { class: "form-check mt-3" }
const _hoisted_22 = {
  class: "form-check-label",
  for: "alwaysOpenInClient"
}
const _hoisted_23 = {
  key: 4,
  class: "alert alert-success position-fixed bottom-0 end-0 m-3 fade show",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.streamedData && !_ctx.isDrafting && !_ctx.savedStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passReasons, (reason) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: reason.id
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                name: "btnradio",
                id: reason.id,
                autocomplete: "off",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedID) = $event)),
                value: reason.id
              }, null, 8, _hoisted_3), [
                [_vModelRadio, _ctx.selectedID]
              ]),
              _createElementVNode("label", {
                class: "btn btn-outline-primary",
                for: reason.id,
                onClick: ($event: any) => (_ctx.selectedID = reason.id)
              }, _toDisplayString(reason.label), 9, _hoisted_4)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.savedStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true),
    (_ctx.isDrafting && !_ctx.streamedData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true),
    ((_ctx.streamedData && _ctx.isDrafting) || _ctx.finishedDrafting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "form-control",
              id: "emailTo",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localEmailAddress) = $event))
            }, null, 512), [
              [_vModelText, _ctx.localEmailAddress]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "emailSubject",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emailSubject) = $event))
            }, null, 512), [
              [_vModelText, _ctx.emailSubject]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_QuillEditor, {
              content: _ctx.streamedData,
              "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.streamedData) = $event)),
              modules: _ctx.editorModules,
              theme: "snow",
              contentType: "text"
            }, null, 8, ["content", "modules"]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
              class: "btn btn-sm btn-secondary position-absolute bottom-0 end-0 mb-1 me-1"
            }, _hoisted_19)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      (!_ctx.streamedData && !_ctx.isDrafting && !_ctx.savedStatus)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.isActionsEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_b_button, {
                    class: "mt-3 btn btn-secondary btn-sm",
                    onClick: _ctx.save
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Save")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_b_button, {
                    class: "mt-3 btn btn-primary btn-sm",
                    onClick: _ctx.saveDraft
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Save & Draft Email")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (_openBlock(), _createBlock(_component_b_button, {
                  key: 1,
                  class: "mt-3 btn btn-primary btn-sm w-100",
                  onClick: _ctx.saveDraft
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Draft Pass Email")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.streamedData)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.alwaysOpenInClient) = $event)),
                id: "alwaysOpenInClient"
              }, null, 512), [
                [_vModelCheckbox, _ctx.alwaysOpenInClient]
              ]),
              _createElementVNode("label", _hoisted_22, " Auto Open " + _toDisplayString(_ctx.loginType === 'gsuite' ? 'Gmail' : 'Email App'), 1)
            ]),
            _createVNode(_component_b_button, {
              class: "mt-3 btn btn-primary btn-sm",
              onClick: _ctx.openEmail
            }, {
              default: _withCtx(() => [
                _createTextVNode("Open in " + _toDisplayString(_ctx.loginType === 'gsuite' ? 'Gmail' : 'Email App'), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showCopyAlert)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Copied to clipboard! "))
      : _createCommentVNode("", true)
  ]))
}